import type { CustomCellRendererProps } from 'ag-grid-react';
import { GeoAlt } from 'react-bootstrap-icons';

import { useJurisdictions } from '../hooks/useJurisdictions';

export function JurisdictionCell({ valueFormatted }: CustomCellRendererProps) {
  const { data: jurisdictions } = useJurisdictions();

  if (!valueFormatted) {
    return '';
  }

  const jurisdiction = jurisdictions?.find((j) => j.id == valueFormatted);

  return (
    <div>
      <GeoAlt />{' '}
      <span className="badge rounded-pill" style={{ backgroundColor: jurisdiction?.color }}>
        {valueFormatted}
      </span>{' '}
      {jurisdiction?.name}
    </div>
  );
}
